
import '../../../style.css';
import star from '../../../assets/star.png';
import check from '../../../assets/check.png';
import nene from '../../../assets/nene.png';
import checkgray from '../../../assets/checkgray.png';

import Modal from 'react-modal';
import { useSelector } from 'react-redux';
import 'chart.js/auto';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS } from 'chart.js';
import { useEffect, useState } from 'react';

import DoneMilestone from '../DoneMilestone';
import { Milestone } from '../../../interfaces/progress';
import NextMilestone from '../NextMilestone';
import ProgressByArea from '../ProgressByArea';
import Alerts from '../Alerts';
import Loader from '../../../components/Loader';
import { customStyles2 } from '../../../theme/global';
import AnswerInModal from '../AnswerInModal';

ChartJS.register()

Modal.setAppElement('#root');

const data = {
    labels: [],
    datasets: [],
};

type ChartData ={
    labels: any[],
    datasets: any[]
}

// const interactions = ["1","5","7"];

const weekDays = [
    {id:"1", name: "L"},
    {id:"2", name: "M"},
    {id:"3", name: "Mi"},
    {id:"4", name: "J"},
    {id:"5", name: "V"},
    {id:"6", name: "S"},
    {id:"7", name: "D"},
]

const MilestonesReportSpanish = () => {

    const state = useSelector( (state:any) => state.milestones);
    const [dataGrafico, setDataGrafico] = useState<ChartData>(data);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);
    const [showModal, setShowModal] = useState(false);

    const {
        done_milestones,
        next_milestones,
        failed_milestones,
        progress,
        total_stage_milestones,
        interactions
    } = state;

    useEffect(() => {
        const data1 = progress.map((item:any) => ({
            labels: item.area.name,
            values: Number((item.completed * 100) / total_stage_milestones).toFixed(0)
        }));
        const data2 = {
            labels: data1.map((item:any) => item.labels),
            datasets: [{
                data: data1.map((item:any) => item.values),
                backgroundColor: [
                    '#00FFFF',
                    '#34A853',
                    '#F1C232',
                ],
                borderColor: [
                    '#00FFFF',
                    '#34A853',
                    '#F1C232',
                ],
                borderWidth: 1
            }]
        }
        setDataGrafico(data2);
        const calculateTotal = data1.reduce((acc:any, current:any) => acc + Number(current.values), 0);
        setTotal(calculateTotal);
        setTimeout(() => {
            setLoading(false);
        },1500)
    },[total_stage_milestones, progress])

    return (
        <div className="page">

            <div className="container">
                <div className="row">
                    <div className="col-sm-4">
                        <div className="baby-info-content">
                            <div>
                                <img src={nene} alt="" width="180" height="auto"
                                className="baby-img"/>
                            </div>
                            <div className="baby-name">
                                <h4>{state.instance_name}</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-8">
                        <div className="info-etapa">
                            <div className="row my-3">
                                <div className="col-sm-9">
                                    <h5 className="etapa-pre-title custom-font">Etapa</h5>
                                    <h3 className="etapa-title custom-font">{state.stage.name}</h3>
                                </div>
                                <div className="col-sm-3">
                                    <img src={state.stage.image_url} alt="" width="90" height="auto"
                                    className="img-etapa"/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <p className="etapa-text custom-font">{state.stage.description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="separador"></div>
                <div className="row">
                    <div className="col-sm-9">
                        <h3 className="custom-font etapa-title mb-3">TU SEMANA EN AFINI</h3>
                        <div className="row">
                            <div className="col-sm-2">
                                <div className="d-flex justify-content-center align-items-center"
                                style={{height: "100%"}}>
                                    <img src={star} alt="" width="90" height="auto" style={{transform: "rotate(90deg)"}}/>
                                </div>
                            </div>
                            <div className="col-sm-10">
                                <div className="row">
                                    {weekDays.map((item: any) => (
                                        <div className="col" key={item.id}>
                                            <div>
                                                <h4 className="custom-font text-center week-day">{item.name}</h4>
                                                <img src={interactions.includes(item.id) ? check : checkgray} alt="" className="check-mark"/>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <p className="my-4 custom-font text-center" style={{fontSize: 22, color: "#545454"}}>{interactions.length} Días de uso afini en esta semana</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <div style={{ backgroundColor: "#eaf6f6", padding: '20px', borderRadius: "10px", boxShadow: '0 0  5px 0 rgba(0,0,0,.2)'}}>
                            <h2 style={{color: "#80cc28"}} className="custom-font">¡Felicidades!</h2>
                            <p className="custom-font" style={{ color: "#09b5ee", fontSize: 20}}>Has utilizado Afini con mucha frecuencia. ¡Sigue Asi!</p>
                        </div>
                    </div>
                </div>
                <div className="separador"></div>
                <div className="row">
                    <div className="col-sm-12">
                        <h3 className="custom-font mb-4 text-center" style={{ color: "#09b5ee"}}>LOGROS COMPLETADOS EN LA ETAPA: {state.stage.name}</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="p-1">
                            <h3 className="custom-font" style={{ color: "#7ed957",fontWeight: 600}}>¡FELICIDADES!</h3>
                            <p style={{color: "#737373", fontWeight: 400, fontSize: 18}}
                            className="custom-font">Vamos muy bien en los siguientes logros</p>
                            {done_milestones.length > 0 ? (
                               done_milestones.map((item:Milestone, idx: number) => <DoneMilestone item={item} key={idx}/>)
                            ) : (
                                <div className="alert alert-info">No hay datos para mostrar</div>
                            )}

                        </div>
                    </div>
                    <div className="col-sm-6" style={{ borderLeft: '3px solid grey'}}>
                        <div className="p-21">
                            <h3 style={{ color: "#f4717f", fontWeight: 600}}
                            className="custom-font">¡SIGUE TRABAJANDO!</h3>
                            <div className="row">
                                <div className="col-sm-12">
                                    <p
                                    style={{color: "#737373", fontWeight: 400, fontSize: 18}}
                                    className="custom-font">
                                        Los siguientes logros
                                    </p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    {failed_milestones.length > 0 ? (
                                        failed_milestones.map((item:Milestone, idx: number) => <NextMilestone item={item} key={idx} />)
                                    ): (
                                        <div className="alert alert-info">No hay info para mostrar</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr />
                <div className="row mb-4 mt-4 pt-2">
                    <div className="col-sm-12 text-center">
                        <button className="btn btn-outline-primary mb-3 custom-font" type="button"
                        onClick={() => setShowModal(true)}
                        style={{borderRadius: '50px'}}>Cambiar respuestas</button>
                        <p style={{ color: 'grey'}}
                        className="custom-font">Si quieres cambiar alguna de tus respuestas, presiona el boton</p>
                    </div>
                </div>
                <hr />

                <div className="row mt-4">
                    <div className="col-sm-6">
                        {loading ? (
                            <Loader />
                        ) : (
                            <>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h3 className="custom-font mb-3"
                                        style={{color: '#737373'}}>TU PROGRESO</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div style={{ display: "flex", height: "100%", justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                                            <h1 className="text-center custom-font"
                                            style={{fontSize: '60px', fontWeight:400, color: '#737373'}}
                                            >{total}%</h1>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <Doughnut data={dataGrafico} />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    <div className="col-sm-6">
                        <div className="d-flex justify-content-center" style={{ flexDirection: 'column', padding: '40px 0'}}>
                            <ProgressByArea items={progress} lang="es"/>
                        </div>
                    </div>
                </div>
                <div className="separador"></div>
                <div className="row">
                    <div className="col-sm-12">
                        <h3
                        className="custom-font"
                        style={{ color: "#F1C232", fontSize: 40}}>¡Vamos a trabajar en!</h3>
                        {next_milestones.length > 0 ? (
                            next_milestones.map((item: Milestone, idx: any) => <Alerts item={item} key={idx}/>)
                        ) : (
                            <div className="alert alert-info">No hay info para mostrar</div>
                        )}
                    </div>
                </div>
                <div className="separador"></div>
            </div>

            <Modal
                isOpen={showModal}
                onRequestClose={()=> setShowModal(false)}
                style={customStyles2}
                contentLabel="Example Modal"
            >
                <AnswerInModal onClose={() => {
                    window.location.reload();
                    setShowModal(false);
                }}
                lang="es"
                />
            </Modal>
        </div>
    )
}

export default MilestonesReportSpanish
